import { render } from "./XATable.vue?vue&type=template&id=2c45dd70"
import script from "./XATable.vue?vue&type=script&lang=js"
export * from "./XATable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__